export default __webpack_public_path__ + "static/404-442ce32c09624585bc001664c9ff9358.gif";